import { Skeleton } from 'primereact/skeleton';

export const UnitFocusSkeleton = (): JSX.Element => (
  <div role="status" aria-label="Loading unit progress" className="tw-flex tw-w-full tw-flex-col tw-gap-4">
    <Skeleton height="2.75rem" borderRadius="9999px" />
    <div className="tw-flex tw-w-full tw-items-start tw-gap-4">
      <Skeleton height="2.75rem" borderRadius="12px" className="tw-flex-1" />
      <Skeleton width="18rem" height="2.75rem" borderRadius="12px" className="tw-shrink-0" />
    </div>
    <div className="tw-flex tw-w-full tw-flex-col tw-items-end tw-gap-3">
      <div className="tw-h-0.5 tw-w-full tw-bg-neutral-100" />
      <Skeleton width="9rem" height="1rem" />
    </div>
  </div>
);
